"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductHero = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const views_1 = require("./views");
function ProductHero({ slug, className, onProductAdd, }) {
    const { data, loading } = (0, app_1.useQuery)('getProduct', {
        args: { slug },
        select: {
            title: true,
            description: true,
            trackInventory: true,
            variants: {
                inventory: true,
                price: {
                    sale: true,
                    price: {
                        amount: true,
                    },
                },
                regularPrice: {
                    sale: true,
                    price: {
                        amount: true,
                    },
                },
                lowestPriceBeforeSale: {
                    sale: true,
                    price: {
                        amount: true,
                    },
                },
                attributes: {
                    value: true,
                    attribute: {
                        title: true,
                    },
                },
            },
            images: true,
            category: {
                title: true,
            },
            attributes: {
                title: true,
                values: {
                    value: true,
                },
                static: true,
            },
            price: {
                price: true,
                lowestPriceBeforeSale: true,
                regularPrice: true,
                otherPrices: true,
                currency: true,
            },
        },
    });
    const { variants } = data !== null && data !== void 0 ? data : {};
    if (!variants) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(views_1.ProductHeroView, { className: className, description: data === null || data === void 0 ? void 0 : data.description, variants: variants, product: data !== null && data !== void 0 ? data : undefined, loading: loading, onProductAdd: onProductAdd }));
}
exports.ProductHero = ProductHero;
